import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'tab']

  connect() {
    this.contentTargets.forEach(content => content.style.display = 'none')
    this.tabTargets[0].click()

    this.name = this.element.dataset.controller
    document.addEventListener('turbo:morph', this.reconnect.bind(this))
  }

  show() {
    const tabName = event.currentTarget.dataset.tabName

    this.tabTargets.forEach(tab => tab.closest('li').classList.remove('is-active'))
    event.currentTarget.closest('li').classList.add('is-active')

    this.contentTargets.forEach(content => content.style.display = 'none')

    this.contentTargets
        .filter(content => content.dataset.tabName == tabName)
        .forEach(content => content.style.display = '')
  }

  reconnect() {
    setTimeout(() => this.element.setAttribute('data-controller', this.name), 1)
    this.element.setAttribute('data-controller', '')
  }
}
